import styled from 'styled-components'

const Container = styled.div`
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
`
const BoxContainer = styled.div`
        border-radius: 15px;
    border: solid 1px #87cdf1;
    overflow: hidden;
    margin-top:7px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
`
const InfoDetailWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(292px, 1fr));
`
const InfoHeading = styled.div`
    font-family: "latobold";
`
const InfoDetail = styled.div`
    font-size: 15px;
    margin: 5px 0;
`
const Heading = styled.div`
   background-color: #87CDF1;
    font-size: 17px;
    color: #ffffff;
    padding: 11px 16px;
    overflow: hidden;
`

const InfoWrapperBox = styled.div`
    padding: 10px 17px;
    flex: 1;
`

const TableWrapper = styled.div`
    border-radius: 5px;
    border: solid 1px #87cdf1;
    margin-bottom: 20px;
    box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
    .table thead th {
        vertical-align: top;
    }
    .MuiPagination-ul {
        padding: 15px;
    }
    .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-root {
    opacity: 1;
    text-transform: capitalize;
    font-family: "latomedium";
    padding: 15px !important;
  }
  .MuiAppBar-colorPrimary {
    color: #7a7a7a;
    background-color: transparent;
    box-shadow: none;
    text-transform: capitalize;
  }
  .MuiTabs-indicator {
    border: solid 2px #2fb5f1;
    /* color: #0a1f30; */
  }
`
export { Container, BoxContainer, InfoDetailWrapper, InfoHeading, InfoDetail, Heading, InfoWrapperBox, TableWrapper }